(function () {
  function money(cents, format) {
    if (typeof window.vibeeMoneyDisplay === 'function') return window.vibeeMoneyDisplay(cents, format);
    if (typeof window.vibeeMoney === 'function') return window.vibeeMoney(cents, format);
    if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, format || window.Shopify.money_format);
    }
    return (Number(cents || 0) / 100).toFixed(2) + ' TL';
  }

  // Hesaplanan tutarlar (set toplamı, tasarruf) kuruşsuz basılır (P59).
  function moneyFloor(cents) {
    if (typeof window.vibeeMoneyFloor === 'function') return window.vibeeMoneyFloor(cents);
    var s = String(Math.max(0, Math.floor(Number(cents || 0) / 100)));
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' TL';
  }

  function savingsPercent(listCents, subCents) {
    if (!listCents || listCents <= subCents) return 0;
    return Math.round(((listCents - subCents) * 100) / listCents);
  }

  function formatSavings(template, percent) {
    if (!template) return '%' + percent + ' tasarruf';
    return template
      .replace(/\{\{\s*percent\s*\}\}/g, String(percent))
      .replace(/%PERCENT%/g, String(percent))
      .replace(/%PERCENT/g, String(percent))
      .replace(/PERCENT/g, String(percent));
  }

  function updatePurchaseState(section, state) {
    section.querySelectorAll('[data-vibee-pdp-purchase-mode]').forEach(function (el) {
      el.value = state.mode;
    });
    section.querySelectorAll('[data-vibee-pdp-selling-plan-prop]').forEach(function (el) {
      el.value = state.sellingPlan;
      el.disabled = !state.sellingPlan;
    });
    section.querySelectorAll('[data-vibee-pdp-selling-plan]').forEach(function (el) {
      el.value = state.sellingPlan;
      el.disabled = !state.sellingPlan;
    });
    section.querySelectorAll('[data-vibee-pdp-bundle-id]').forEach(function (el) {
      el.value = state.bundleId;
      el.disabled = !state.bundleId;
    });
  }

  function safeSubmit(form) {
    if (form.requestSubmit) {
      form.requestSubmit();
      return;
    }
    var tmp = document.createElement('button');
    tmp.type = 'submit';
    tmp.style.display = 'none';
    form.appendChild(tmp);
    tmp.click();
    form.removeChild(tmp);
  }

  /**
   * @returns {Promise<object>}
   */
  function fetchCartJson() {
    return fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_fetch_failed');
      return response.json();
    });
  }

  function isCartAddNetworkError(err) {
    return !!(err && err.code === 'network');
  }

  function isCartAddParseAfterSuccess(err) {
    return !!(err && err.code === 'parse' && err.responseOk);
  }

  function getCartPageUrl() {
    try {
      var node = document.getElementById('vibee-cart-drawer-config');
      if (node) {
        var cfg = JSON.parse(node.textContent || '{}');
        if (cfg.cartUrl) return cfg.cartUrl;
      }
    } catch (e) {}
    return '/cart';
  }

  function showAddFallbackNotice() {
    // Minimal onay — ayrı "Sepete git" adımı yok (Tem 2026 kararı).
    var el = document.querySelector('[data-vibee-cart-drawer-error]');
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
    el.appendChild(document.createTextNode('✓ Sepete eklendi'));
    el.hidden = false;
    el.classList.add('is-visible');
    window.setTimeout(function () {
      el.hidden = true;
      el.classList.remove('is-visible');
    }, 2400);
  }

  /** Drawer open when available; otherwise header count + /cart notice. */
  function syncCartFeedback(cart, addResult, attempt) {
    // Mobil karar (Tem 2026): drawer yerine flat /cart sayfası — ekleme
    // başarılı olduğunda doğrudan sepete git. Desktop drawer'da kalır.
    if (window.matchMedia('(max-width: 749px)').matches) {
      window.location.assign(getCartPageUrl());
      return;
    }
    var drawer = window.vibeeCartDrawer;
    if (drawer && typeof drawer.syncAfterAdd === 'function') {
      drawer.syncAfterAdd(cart, addResult);
      // Sessiz başarısızlık sigortası: drawer 700ms içinde gerçekten açılmadıysa
      // en azından görünür bir onay göster — kullanıcı asla boşlukta kalmaz.
      window.setTimeout(function () {
        var el = document.querySelector('[data-vibee-cart-drawer]');
        if (!el || !el.classList.contains('is-open')) showAddFallbackNotice();
      }, 700);
      return;
    }
    // Drawer JS geç yükleniyorsa kısa süre bekle (yavaş mobil race'i)
    attempt = Number(attempt || 0);
    if (attempt < 5) {
      window.setTimeout(function () {
        syncCartFeedback(cart, addResult, attempt + 1);
      }, 300);
      return;
    }
    if (drawer && typeof drawer.updateHeaderCartCount === 'function') {
      drawer.updateHeaderCartCount(cart);
    }
    if (drawer && typeof drawer.dispatchCartEvents === 'function') {
      drawer.dispatchCartEvents(cart);
    }
    showAddFallbackNotice();
  }

  /**
   * @param {RequestInit} init
   * @returns {Promise<object>}
   */
  function postCartAddJson(init) {
    return fetch('/cart/add.js', init)
      .then(function (response) {
        return response.text().then(function (text) {
          var body = {};
          if (text) {
            try {
              body = JSON.parse(text);
            } catch (parseErr) {
              var parseError = new Error('add_parse_failed');
              parseError.code = 'parse';
              parseError.responseOk = response.ok;
              throw parseError;
            }
          }
          if (!response.ok) {
            var httpErr = new Error('add_failed');
            httpErr.code = 'http';
            httpErr.body = body;
            throw httpErr;
          }
          return body;
        });
      })
      .catch(function (err) {
        if (err && err.code) throw err;
        var netErr = new Error('add_network_failed');
        netErr.code = 'network';
        throw netErr;
      });
  }

  /**
   * POST /cart/add.js → GET /cart.js → drawer or header/fallback feedback.
   * @param {RequestInit} init
   * @returns {Promise<object>}
   */
  function vibeeCartAddAndSync(init) {
    return postCartAddJson(init)
      .then(function (addResult) {
        return fetchCartJson().then(function (cart) {
          syncCartFeedback(cart, addResult);
          return cart;
        });
      })
      .catch(function (err) {
        if (isCartAddParseAfterSuccess(err)) {
          return fetchCartJson().then(function (cart) {
            syncCartFeedback(cart, null);
            return cart;
          });
        }
        throw err;
      });
  }

  /**
   * @param {HTMLFormElement} form
   * @returns {object}
   */
  function buildCartAddPayloadFromForm(form) {
    var fd = new FormData(form);
    var item = {
      id: Number(fd.get('id')),
      quantity: Number(fd.get('quantity') || 1),
    };
    var sellingPlan = fd.get('selling_plan');
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    var properties = {};
    fd.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (match && value !== '') properties[match[1]] = String(value);
    });
    // Tek seferlik alımda _purchase_mode property'si GÖNDERİLMEZ — aksi halde
    // aynı varyant, cross-sell'in çıplak eklediği satırla birleşemez ve
    // sepette aynı ürün iki ayrı satır olarak görünür (Tem 2026 fix).
    if (properties._purchase_mode === 'onetime') delete properties._purchase_mode;
    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }

  function initPurchaseSelector(section, state, callbacks) {
    var purchaseRoot = section.querySelector('[data-vibee-pdp-purchase]');
    if (!purchaseRoot) return null;

    var dataNode = purchaseRoot.querySelector('[data-vibee-pdp-purchase-data]');
    var purchaseData = { variants: {}, defaultPeriod: 30 };
    try {
      if (dataNode) purchaseData = JSON.parse(dataNode.textContent);
    } catch (e) {
      console.error('vibee-pdp purchase JSON parse error', e);
    }

    var subRow = purchaseRoot.querySelector('[data-vibee-pdp-purchase-sub-row]');
    var modeRadios = purchaseRoot.querySelectorAll('[data-vibee-pdp-purchase-mode-radio]');
    var subPriceEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-sub-price]');
    var subCompareEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-sub-compare]');
    var subIntervalEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-interval]');
    var subBadgeEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-badge]');
    var onetimePriceEl = purchaseRoot.querySelector('[data-vibee-pdp-purchase-onetime-price]');
    var periodsWrap = purchaseRoot.querySelector('[data-vibee-pdp-periods]');
    var periodBtns = purchaseRoot.querySelectorAll('[data-vibee-pdp-period]');
    var labels = {
      ctaSub: purchaseRoot.getAttribute('data-label-cta-sub') || 'DÜZENLİ TESLİMATLA AL',
      ctaOnetime: purchaseRoot.getAttribute('data-label-cta-onetime') || 'SEPETE EKLE',
      savings: purchaseRoot.getAttribute('data-label-savings') || '%PERCENT tasarruf'
    };
    var productHandle = purchaseRoot.getAttribute('data-product-handle') || '';
    // Seçili teslimat periyodu (gün). Varsayılan 30 = en yüksek indirim.
    var selectedPeriod = Number(purchaseRoot.getAttribute('data-default-period')) ||
      Number(purchaseData.defaultPeriod) || 30;

    function optionLabels() {
      return purchaseRoot.querySelectorAll('.vibee-pdp__purchase-option');
    }

    function syncSelectedCards() {
      optionLabels().forEach(function (label) {
        var input = label.querySelector('[data-vibee-pdp-purchase-mode-radio]');
        label.classList.toggle('is-selected', !!(input && input.checked));
      });
      if (periodsWrap) periodsWrap.hidden = state.mode !== 'subscription';
    }

    function getCheckedMode() {
      var checked = purchaseRoot.querySelector('[data-vibee-pdp-purchase-mode-radio]:checked');
      return checked && checked.value === 'subscription' ? 'subscription' : 'onetime';
    }

    // Varyantın seçili periyoduna ait kayıt (yoksa ilk periyot).
    function periodOf(variantData, days) {
      var list = (variantData && variantData.periods) || [];
      var want = days || selectedPeriod;
      for (var i = 0; i < list.length; i++) {
        if (Number(list[i].days) === Number(want)) return list[i];
      }
      return list.length ? list[0] : null;
    }

    // Abonelik CTA'sı sepete EKLEMEZ; iyzico abonelik akışına gider.
    function externalCheckoutUrl(variantData) {
      var per = periodOf(variantData);
      if (!variantData || !variantData.sku || !per || !per.planRef) return '';
      return '/pages/duzenli-teslimat?sku=' + encodeURIComponent(variantData.sku) +
        '&handle=' + encodeURIComponent(productHandle) +
        '&plan_ref=' + encodeURIComponent(per.planRef) +
        '&period=' + encodeURIComponent(per.days);
    }

    function syncPeriodButtons() {
      periodBtns.forEach(function (btn) {
        var active = Number(btn.getAttribute('data-days')) === Number(selectedPeriod);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function applyVariant(variantId) {
      var vd = purchaseData.variants[String(variantId)] || purchaseData.variants[variantId];
      if (!vd) return;

      if (onetimePriceEl) onetimePriceEl.textContent = money(vd.onetimePrice);

      if (vd.hasSubscription) {
        if (subRow) subRow.hidden = false;
        var per = periodOf(vd);
        if (per) {
          if (subPriceEl) subPriceEl.textContent = money(per.price);
          if (subIntervalEl) subIntervalEl.textContent = '/ ' + per.days + ' gün';
          if (subCompareEl) {
            subCompareEl.textContent = money(vd.onetimePrice);
            subCompareEl.hidden = !(vd.onetimePrice > per.price);
          }
          if (subBadgeEl) {
            subBadgeEl.textContent = String(labels.savings).replace(/PERCENT/g, String(per.discount));
            subBadgeEl.hidden = !(per.discount > 0);
          }
        }
      } else {
        if (subRow) subRow.hidden = true;
        if (state.mode === 'subscription') {
          state.mode = 'onetime';
          modeRadios.forEach(function (radio) {
            if (radio.value === 'onetime') radio.checked = true;
          });
        }
      }

      syncPeriodButtons();
      syncSelectedCards();
      if (callbacks && callbacks.onVariantApplied) callbacks.onVariantApplied(vd);
    }

    modeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        state.mode = radio.value === 'subscription' ? 'subscription' : 'onetime';
        state.bundleId = '';
        // iyzico external abonelik: Shopify selling plan yok, sepete eklenmez.
        state.sellingPlan = '';
        syncSelectedCards();
        updatePurchaseState(section, state);
        if (callbacks && callbacks.onModeChange) callbacks.onModeChange();
      });
    });

    periodBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var days = Number(btn.getAttribute('data-days'));
        if (!days || days === selectedPeriod) return;
        selectedPeriod = days;
        syncPeriodButtons();
        if (state.variantId) applyVariant(state.variantId);
        if (callbacks && callbacks.onModeChange) callbacks.onModeChange();
      });
    });

    return {
      applyVariant: applyVariant,
      getVariantData: function (variantId) {
        return purchaseData.variants[String(variantId)];
      },
      externalCheckoutUrl: externalCheckoutUrl,
      getSelectedPeriod: function () { return selectedPeriod; },
      getShownPrice: function (variantId) {
        var vd = purchaseData.variants[String(variantId)];
        if (!vd) return state.basePrice;
        if (state.mode === 'subscription' && vd.hasSubscription) {
          var per = periodOf(vd);
          if (per) return per.price;
        }
        return vd.onetimePrice;
      },
      getCtaPrefix: function () {
        return state.mode === 'subscription' ? labels.ctaSub : labels.ctaOnetime;
      },
      getCtaSuffix: function (variantId) {
        var vd = purchaseData.variants[String(variantId)];
        if (!vd || !vd.hasSubscription || state.mode !== 'subscription') return '';
        var per = periodOf(vd);
        return per ? ' / ' + per.days + ' GÜN' : '';
      },
      syncSelectedCards: syncSelectedCards
    };
  }

  function initBeforeAfter(section) {
    var root = section.querySelector('[data-before-after]');
    if (!root) return;
    var buttons = root.querySelectorAll('.vibee-pdp__facet-btn');
    var cards = root.querySelectorAll('.vibee-pdp__before-card');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var facet = btn.getAttribute('data-facet');
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        cards.forEach(function (card) {
          var facetValue = card.getAttribute('data-skin-type') || card.getAttribute('data-shade') || '';
          card.hidden = facet !== 'all' && facetValue !== facet;
        });
      });
    });
  }

  function initShadeSelector(section) {
    var root = section.querySelector('[data-vibee-shade-selector]');
    if (!root) return;
    var shadeButtons = root.querySelectorAll('[data-vibee-shade]');
    var variantSelect = section.querySelector('[data-vibee-pdp-variant-select]');
    if (!shadeButtons.length || !variantSelect) return;

    function setActive(btn) {
      shadeButtons.forEach(function (x) {
        x.classList.toggle('is-active', x === btn);
        if (x === btn) x.setAttribute('aria-current', 'true');
        else x.removeAttribute('aria-current');
      });
    }

    shadeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        variantSelect.value = variantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        setActive(btn);
      });
    });
  }

  function initShadeQuiz(section) {
    var root = section.querySelector('[data-vibee-shadequiz]');
    if (!root) return;
    var openBtn = root.querySelector('[data-vibee-shadequiz-open]');
    var panel = root.querySelector('[data-vibee-shadequiz-panel]');
    var submit = root.querySelector('[data-vibee-shadequiz-submit]');
    var result = root.querySelector('[data-vibee-shadequiz-result]');
    var fields = root.querySelectorAll('[data-shadequiz-key]');
    var rulesUrl = root.getAttribute('data-rules-url');
    var rulesetId = root.getAttribute('data-ruleset-id');
    if (!openBtn || !panel || !submit || !result || !rulesUrl || !rulesetId) return;

    openBtn.addEventListener('click', function () {
      panel.hidden = false;
    });

    submit.addEventListener('click', function () {
      var answers = {};
      fields.forEach(function (field) {
        var key = field.getAttribute('data-shadequiz-key');
        answers[key] = (field.value || '').trim();
      });

      fetch(rulesUrl)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var ruleset = (json.rulesets || {})[rulesetId];
          if (!ruleset) return;
          var found = null;
          (ruleset.rules || []).forEach(function (rule) {
            if (found) return;
            var ok = true;
            Object.keys(rule.match || {}).forEach(function (k) {
              if (String(answers[k] || '') !== String(rule.match[k])) ok = false;
            });
            if (ok) found = rule.result;
          });
          var finalResult = found || ruleset.fallback || {};
          var shadeSku = String(finalResult.shadeSku || '').toUpperCase();
          var shadeButtons = section.querySelectorAll('[data-vibee-shade]');
          var target = null;
          shadeButtons.forEach(function (btn) {
            var variantId = btn.getAttribute('data-variant-id');
            if (!variantId || target) return;
            var opt = section.querySelector('[data-vibee-pdp-variant-select] option[value="' + variantId + '"]');
            if (!opt) return;
            var sku = (opt.getAttribute('data-sku') || '').toUpperCase();
            if (sku === shadeSku || sku.indexOf(shadeSku + '-') === 0 || shadeSku.indexOf(sku + '-') === 0) target = btn;
          });
          if (target) {
            target.click();
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
          result.hidden = false;
          result.innerHTML = '<strong>Senin tonun: ' + (finalResult.shadeLabelTr || '-') + '</strong><br><span>' + (finalResult.noteTr || '') + '</span>';
          try {
            sessionStorage.setItem('vibee-shade-quiz', JSON.stringify(answers));
          } catch (e) {}
        });
    });
  }

  function initQuiz(section) {
    var quizNode = section.querySelector('[data-vibee-quiz]');
    if (!quizNode) return;
    var openButton = quizNode.querySelector('[data-vibee-wa-open]');
    var modal = quizNode.querySelector('[data-vibee-wa-modal]');
    var closeButton = quizNode.querySelector('[data-vibee-wa-close]');
    var goButton = quizNode.querySelector('[data-vibee-wa-go]');
    var consent = quizNode.querySelector('[data-vibee-wa-consent]');
    var fields = quizNode.querySelectorAll('[data-quiz-key]');
    if (!openButton || !modal || !closeButton || !goButton || !consent) return;

    var rawNumber = String(modal.getAttribute('data-wa-number') || '');
    var number = rawNumber.replace(/[^\d]/g, '');

    function lockScroll() {
      document.body.classList.add('vibee-pdp--scroll-lock');
    }

    function unlockScroll() {
      document.body.classList.remove('vibee-pdp--scroll-lock');
    }

    function openModal() {
      modal.hidden = false;
      lockScroll();
    }

    function closeModal() {
      modal.hidden = true;
      unlockScroll();
    }

    function syncGoState() {
      var canGo = number && consent.checked;
      if (!number) {
        goButton.disabled = true;
      } else {
        goButton.disabled = !canGo;
      }
    }

    openButton.addEventListener('click', openModal);
    closeButton.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
    consent.addEventListener('change', syncGoState);
    syncGoState();

    goButton.addEventListener('click', function () {
      if (!number || goButton.disabled) return;

      var payload = {};
      fields.forEach(function (field) {
        var key = field.getAttribute('data-quiz-key');
        var value = (field.value || '').trim();
        if (value) payload[key] = value;
      });

      var qpUrl = new URL(window.location.href);
      qpUrl.searchParams.set('quiz', encodeURIComponent(JSON.stringify(payload)));
      window.history.replaceState({}, '', qpUrl.toString());
      try {
        sessionStorage.setItem('vibee-wa-quiz', JSON.stringify(payload));
      } catch (e) {}

      var titleEl = section.querySelector('.vibee-pdp__title');
      var productTitle = titleEl ? titleEl.textContent.trim() : (document.title || '');
      var parts = ['Merhaba, cilt analizi istiyorum.'];
      if (payload.skinType) parts.push('Cilt tipim: ' + payload.skinType + '.');
      if (payload.concern) parts.push('Ana endişem: ' + payload.concern + '.');
      if (payload.routine) parts.push('Rutinim: ' + payload.routine + '.');
      parts.push('Ürün: ' + productTitle + '.');
      var msg = parts.join(' ');

      window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(msg), '_blank');
    });
  }

  function initGallery(section) {
    var gallery = section.querySelector('[data-vibee-pdp-gallery]');
    if (!gallery) return null;

    var dataNode = gallery.querySelector('[data-vibee-pdp-gallery-data]');
    var items = [];
    try {
      if (dataNode) items = JSON.parse(dataNode.textContent).items || [];
    } catch (e) {
      console.error('vibee-pdp gallery JSON parse error', e);
    }
    if (!items.length) return null;

    var frame = gallery.querySelector('[data-vibee-pdp-gallery-frame]');
    var layerA = gallery.querySelector('[data-vibee-pdp-layer="a"]');
    var layerB = gallery.querySelector('[data-vibee-pdp-layer="b"]');
    var mobileTrack = gallery.querySelector('[data-vibee-pdp-mobile-track]');
    var counter = gallery.querySelector('[data-vibee-pdp-gallery-counter]');
    var thumbs = gallery.querySelectorAll('[data-vibee-pdp-thumb]');
    var indicator = gallery.querySelector('[data-vibee-pdp-thumb-indicator]');
    var activeIndex = 0;
    var frontLayer = layerA;
    var backLayer = layerB;
    var prefetched = {};

    function isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function prefetchAround(index) {
      [-1, 0, 1].forEach(function (offset) {
        var i = index + offset;
        if (i < 0 || i >= items.length) return;
        var item = items[i];
        if (!item || item.type === 'video' || !item.src) return;
        if (prefetched[item.src]) return;
        prefetched[item.src] = true;
        var img = new Image();
        img.src = item.src;
      });
    }

    function renderImageLayer(layer, item) {
      layer.innerHTML = '';
      if (!item || item.type === 'video') return;
      var img = document.createElement('img');
      img.src = item.src1200 || item.src;
      img.alt = item.alt || '';
      img.className = 'vibee-pdp__gallery-image';
      img.setAttribute('data-vibee-pdp-main-image', '');
      img.sizes = '(min-width: 990px) min(50vw, 520px), 100vw';
      layer.appendChild(img);
    }

    function renderVideoLayer(layer, index) {
      layer.innerHTML = '';
      var slide = gallery.querySelector('[data-vibee-pdp-slide][data-index="' + index + '"]');
      if (!slide) return;
      var sourceVideo = slide.querySelector('video');
      if (!sourceVideo) return;
      var video = sourceVideo.cloneNode(true);
      video.className = 'vibee-pdp__gallery-video';
      video.controls = true;
      layer.appendChild(video);
    }

    function syncThumbs(index) {
      thumbs.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('is-active', active);
        if (active) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });

      if (indicator && thumbs[index]) {
        indicator.style.transform = 'translateY(' + thumbs[index].offsetTop + 'px)';
        indicator.style.height = thumbs[index].offsetHeight + 'px';
      }

      if (counter) counter.textContent = index + 1 + '/' + items.length;
      prefetchAround(index);
    }

    function crossfadeTo(index) {
      if (index < 0 || index >= items.length) return;
      activeIndex = index;
      syncThumbs(index);

      var item = items[index];
      var incoming = backLayer;
      var outgoing = frontLayer;

      if (item.type === 'video') renderVideoLayer(incoming, index);
      else renderImageLayer(incoming, item);

      outgoing.classList.remove('is-active');
      incoming.classList.add('is-incoming', 'is-active');

      window.setTimeout(function () {
        incoming.classList.remove('is-incoming');
        outgoing.classList.remove('is-active', 'is-incoming');
        outgoing.innerHTML = '';
        frontLayer = incoming;
        backLayer = outgoing;
      }, 280);
    }

    function scrollMobileTo(index) {
      if (!mobileTrack) return;
      var slide = mobileTrack.querySelector('[data-vibee-pdp-slide][data-index="' + index + '"]');
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    if (layerA) {
      if (items[0].type === 'video') renderVideoLayer(layerA, 0);
      else renderImageLayer(layerA, items[0]);
      layerA.classList.add('is-active');
    }
    syncThumbs(0);

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = Number(btn.getAttribute('data-index') || 0);
        if (isDesktop()) crossfadeTo(index);
        else scrollMobileTo(index);
      });
    });

    if (mobileTrack) {
      var scrollTimer;
      function syncFromScroll() {
        var slides = mobileTrack.querySelectorAll('[data-vibee-pdp-slide]');
        var trackRect = mobileTrack.getBoundingClientRect();
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var rect = slide.getBoundingClientRect();
          var dist = Math.abs(rect.left - trackRect.left);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        if (best !== activeIndex) {
          activeIndex = best;
          syncThumbs(best);
        }
      }
      mobileTrack.addEventListener(
        'scroll',
        function () {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(syncFromScroll, 80);
        },
        { passive: true },
      );
      mobileTrack.addEventListener('scrollend', syncFromScroll, { passive: true });
    }

    if (frame) {
      frame.addEventListener('mousemove', function (e) {
        if (!isDesktop()) return;
        var rect = frame.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        frame.querySelectorAll('.vibee-pdp__gallery-layer.is-active img').forEach(function (img) {
          img.style.transformOrigin = x + '% ' + y + '%';
        });
        frame.classList.add('is-zoom-ready');
      });
      frame.addEventListener('mouseleave', function () {
        frame.classList.remove('is-zoom-ready');
      });

      frame.addEventListener('keydown', function (e) {
        if (!isDesktop()) return;
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          crossfadeTo(Math.max(0, activeIndex - 1));
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          crossfadeTo(Math.min(items.length - 1, activeIndex + 1));
        }
      });

      if (window.VibeeLightbox) {
        frame.addEventListener('click', function () {
          if (!isDesktop()) return;
          var item = items[activeIndex];
          if (!item || item.type === 'video') return;
          window.VibeeLightbox.open(items, activeIndex);
        });

        var lastTap = 0;
        frame.addEventListener('touchend', function () {
          var now = Date.now();
          if (now - lastTap < 300) {
            var item = items[activeIndex];
            if (item && item.type !== 'video') window.VibeeLightbox.open(items, activeIndex);
          }
          lastTap = now;
        });
      }
    }

    return {
      goTo: crossfadeTo,
      goToFeaturedMedia: function (mediaId) {
        if (!mediaId) return;
        var targetIndex = -1;
        for (var i = 0; i < items.length; i += 1) {
          if (String(items[i].id) === String(mediaId)) {
            targetIndex = i;
            break;
          }
        }
        if (targetIndex < 0) return;
        if (isDesktop()) crossfadeTo(targetIndex);
        else {
          activeIndex = targetIndex;
          syncThumbs(targetIndex);
          scrollMobileTo(targetIndex);
        }
      },
      getItems: function () { return items; },
    };
  }

  function initSection(section) {
    var variantSelect = section.querySelector('[data-vibee-pdp-variant-select]');
    var variantIdInputs = section.querySelectorAll('[data-vibee-pdp-variant-id]');
    var priceValueEls = section.querySelectorAll('[data-vibee-pdp-price-value]');
    var compareEls = section.querySelectorAll('[data-vibee-pdp-compare]');
    var atcButtons = section.querySelectorAll('[data-vibee-pdp-atc-button]');
    var stickyPrice = section.querySelector('[data-vibee-pdp-sticky-price]');
    var stickyCompare = section.querySelector('[data-vibee-pdp-sticky-compare]');
    var stickyMeta = section.querySelector('[data-vibee-pdp-sticky-meta]');
    var stickySubmit = section.querySelector('[data-vibee-pdp-sticky-submit]');
    var stickyModule = section.querySelector('.vibee-pdp__module--sticky-atc');
    var atcSentinel = section.querySelector('[data-vibee-pdp-atc-button]');
    var buyForm = section.querySelector('[data-vibee-pdp-atc-form]');
    var hasPurchaseSelector = buyForm && buyForm.hasAttribute('data-vibee-pdp-has-purchase-selector');
    var galleryApi = initGallery(section);

    var state = {
      // Varsayılan HER ZAMAN tek seferlik; abonelik kullanıcı seçimiyle açılır.
      mode: 'onetime',
      sellingPlan: '',
      bundleId: '',
      basePrice: 0,
      variantTitle: '',
      variantId: ''
    };

    var purchaseSelector = hasPurchaseSelector
      ? initPurchaseSelector(section, state, {
          onModeChange: function () { updateVisiblePrices(); },
          onVariantApplied: function (vd) {
            if (state.mode === 'subscription' && vd.hasSubscription) {
              state.sellingPlan = vd.sellingPlanId ? String(vd.sellingPlanId) : '';
            } else if (!vd.hasSubscription) {
              state.sellingPlan = '';
            }
            updatePurchaseState(section, state);
            updateVisiblePrices();
          }
        })
      : null;

    updatePurchaseState(section, state);

    function subscriptionPriceSuffix(variantId) {
      if (!purchaseSelector || !variantId || state.mode !== 'subscription') return '';
      return purchaseSelector.getCtaSuffix(variantId);
    }

    function resolvePurchaseAction() {
      // iyzico 3-periyot modeli: abonelik ASLA sepete eklenmez, her zaman
      // external abonelik checkout'una gider (karma sepet oluşmaz).
      if (state.mode === 'subscription' && purchaseSelector) {
        var vd = purchaseSelector.getVariantData(state.variantId);
        if (vd && vd.hasSubscription) {
          return 'external';
        }
      }
      return 'submit';
    }

    function goExternal() {
      if (!purchaseSelector) return false;
      var vd = purchaseSelector.getVariantData(state.variantId);
      var url = purchaseSelector.externalCheckoutUrl(vd);
      if (!url) {
        console.error('vibee-pdp: external checkout URL boş (sku eksik?)', state.variantId);
        return false;
      }
      window.location.assign(url);
      return true;
    }

    if (buyForm) {
      buyForm.addEventListener('submit', function (event) {
        if (buyForm.dataset.vibeeNativeFallback === '1') {
          buyForm.dataset.vibeeNativeFallback = '0';
          buyForm.dataset.cartAdding = '0';
          return;
        }

        event.preventDefault();
        if (buyForm.dataset.cartAdding === '1') return;

        if (purchaseSelector && resolvePurchaseAction() === 'external') {
          goExternal();
          return;
        }

        buyForm.dataset.cartAdding = '1';
        // Guarantee the submitted variant matches the currently-selected option,
        // even if a 'change' event never fired (programmatic selection, some AT).
        // Covers native <select> and shade-swatch products (both expose
        // [data-vibee-pdp-variant-select]).
        if (variantSelect && variantSelect.value) {
          variantIdInputs.forEach(function (input) { input.value = variantSelect.value; });
        }
        var payload = buildCartAddPayloadFromForm(buyForm);
        var addFailed = false;
        var triggerButtons = Array.prototype.slice.call(atcButtons);
        if (stickySubmit) triggerButtons.push(stickySubmit);
        triggerButtons.forEach(function (btn) {
          btn.disabled = true;
          btn.classList.add('is-adding');
          btn.setAttribute('data-prev-label', btn.textContent);
          btn.textContent = 'EKLENİYOR…';
        });

        vibeeCartAddAndSync({
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload),
        })
          .catch(function (err) {
            if (isCartAddNetworkError(err)) {
              buyForm.dataset.vibeeNativeFallback = '1';
              buyForm.dataset.cartAdding = '0';
              triggerButtons.forEach(function (btn) {
                btn.disabled = false;
              });
              safeSubmit(buyForm);
              return;
            }
            addFailed = true;
            if (window.vibeeCartDrawer && typeof window.vibeeCartDrawer.showError === 'function') {
              window.vibeeCartDrawer.showError();
            }
            triggerButtons.forEach(function (btn) {
              btn.disabled = false; // tekrar dene gerçekten denenebilsin
              btn.textContent = 'Sepete eklenemedi — tekrar dene';
            });
            window.setTimeout(function () {
              triggerButtons.forEach(function (btn) {
                var prev = btn.getAttribute('data-prev-label');
                if (prev) btn.textContent = prev;
                btn.removeAttribute('data-prev-label');
              });
              syncVariant();
            }, 3200);
          })
          .finally(function () {
            triggerButtons.forEach(function (btn) {
              btn.classList.remove('is-adding');
              if (!addFailed) {
                // Tek varyantlı PDP'lerde miras kalan "ölü buton" bug'ının kök çözümü:
                // başarıda butonu KOŞULSUZ yeniden aktifleştir + etiketi geri koy.
                btn.disabled = false;
                var prev = btn.getAttribute('data-prev-label');
                if (prev) btn.textContent = prev;
                btn.removeAttribute('data-prev-label');
              }
            });
            if (buyForm.dataset.vibeeNativeFallback === '1') return;
            buyForm.dataset.cartAdding = '0';
            syncVariant();
          });
      });
    }

    function updateVisiblePrices() {
      var variantId = state.variantId;
      var shownPrice = state.basePrice;
      var ctaPrefix = 'Sepete ekle';

      if (purchaseSelector && variantId) {
        shownPrice = purchaseSelector.getShownPrice(variantId);
        ctaPrefix = purchaseSelector.getCtaPrefix();
      } else if (state.mode === 'subscription') {
        shownPrice = state.basePrice;
      }

      // Pre-order products override the default CTA label (non-subscription only).
      if (!purchaseSelector && buyForm && buyForm.getAttribute('data-preorder-cta')) {
        ctaPrefix = buyForm.getAttribute('data-preorder-cta');
      }

      // shownPrice 0 ise (tükenmiş üründe form render edilmez, fiyat verisi yoktur)
      // sunucunun bastığı doğru fiyatı ezme.
      if (shownPrice) {
        priceValueEls.forEach(function (el) { el.textContent = money(shownPrice) + subscriptionPriceSuffix(variantId); });
      }

      if (stickyPrice) {
        var stickyPriceText = money(shownPrice);
        if (purchaseSelector && variantId && state.mode === 'subscription') {
          var vdSticky = purchaseSelector.getVariantData(variantId);
          if (vdSticky && vdSticky.hasSubscription) {
            stickyPriceText = stickyPriceText + subscriptionPriceSuffix(variantId);
          }
        }
        if (shownPrice) stickyPrice.textContent = stickyPriceText;
      }

      if (stickyMeta) {
        var stickyTitle = stickyMeta.getAttribute('data-vibee-pdp-sticky-title') || stickyMeta.textContent || '';
        stickyMeta.textContent = stickyTitle + (state.variantTitle && state.variantTitle !== 'Default Title' ? ' · ' + state.variantTitle : '');
      }

      atcButtons.forEach(function (btn) {
        if (!btn.disabled) {
          btn.textContent = ctaPrefix + ' — ' + money(shownPrice) + subscriptionPriceSuffix(variantId);
        }
      });

      if (stickySubmit && !stickySubmit.disabled) {
        var stickyMod = section.querySelector('.vibee-pdp__module--sticky-atc');
        var stickyLabel = stickyMod
          ? (state.mode === 'subscription' && purchaseSelector
            ? (stickyMod.getAttribute('data-label-sticky-sub') || 'DÜZENLİ TESLİMATLA AL')
            : (stickyMod.getAttribute('data-label-sticky-onetime') || 'SEPETE EKLE'))
          : 'SEPETE EKLE';
        stickySubmit.textContent = stickyLabel;
      }
    }

    function syncGalleryForVariant(selectedOption) {
      if (!galleryApi || !selectedOption) return;
      var mediaId = selectedOption.getAttribute('data-featured-media-id');
      if (mediaId) galleryApi.goToFeaturedMedia(mediaId);
    }

    function syncVariant() {
      if (!variantSelect) {
        var hiddenId = section.querySelector('[data-vibee-pdp-variant-id]');
        if (hiddenId) {
          state.variantId = hiddenId.value;
          var singlePrice = Number(hiddenId.getAttribute('data-price') || 0);
          var singleCompare = Number(hiddenId.getAttribute('data-compare') || 0);
          if (singlePrice) state.basePrice = singlePrice;
          compareEls.forEach(function (el) {
            if (singleCompare > singlePrice) {
              el.textContent = money(singleCompare);
              el.hidden = false;
            } else {
              el.hidden = true;
            }
          });
          if (stickyCompare) {
            if (singleCompare > singlePrice) {
              stickyCompare.textContent = money(singleCompare);
              stickyCompare.hidden = false;
            } else {
              stickyCompare.hidden = true;
            }
          }
        }
        if (purchaseSelector && state.variantId) purchaseSelector.applyVariant(state.variantId);
        updateVisiblePrices();
        return;
      }

      var selected = variantSelect.options[variantSelect.selectedIndex];
      if (!selected) return;
      var variantId = selected.value;
      var price = Number(selected.getAttribute('data-price') || 0);
      var compare = Number(selected.getAttribute('data-compare') || 0);
      var available = String(selected.getAttribute('data-available')) === 'true';
      var title = selected.getAttribute('data-title') || '';

      var variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', variantId);
      window.history.replaceState(window.history.state, '', variantUrl.toString());
      var stickyImage = section.querySelector('.vibee-pdp__sticky img');
      if (stickyImage && selected.getAttribute('data-image')) {
        stickyImage.src = selected.getAttribute('data-image');
        stickyImage.removeAttribute('srcset');
        stickyImage.alt = title;
      }
      section.querySelectorAll('[data-vibee-pdp-discount]').forEach(function (badge) {
        badge.hidden = !(compare > price);
        badge.textContent = compare > price ? '%' + Math.round((compare - price) / compare * 100) : '';
      });
      section.querySelectorAll('[data-vibee-pdp-price]').forEach(function (node) {
        node.classList.toggle('vibee-pdp__price--sale', compare > price);
      });
      var bundleSeed = section.querySelector('[data-bundle-item][data-seed="true"]');
      if (bundleSeed) {
        bundleSeed.setAttribute('data-id', variantId);
        bundleSeed.setAttribute('data-price', price);
        bundleSeed.dispatchEvent(new Event('change', { bubbles: true }));
      }

      state.basePrice = price;
      state.variantTitle = title;
      state.variantId = variantId;

      if (purchaseSelector) {
        purchaseSelector.applyVariant(variantId);
        var vd = purchaseSelector.getVariantData(variantId);
        if (vd && state.mode === 'subscription' && vd.hasSubscription) {
          state.sellingPlan = vd.sellingPlanId ? String(vd.sellingPlanId) : '';
        } else if (!vd || !vd.hasSubscription || state.mode !== 'subscription') {
          if (!vd || !vd.hasSubscription) state.sellingPlan = '';
        }
        updatePurchaseState(section, state);
      }

      variantIdInputs.forEach(function (input) { input.value = variantId; });
      compareEls.forEach(function (el) {
        if (compare > price) {
          el.textContent = money(compare);
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
      if (stickyCompare) {
        if (compare > price) {
          stickyCompare.textContent = money(compare);
          stickyCompare.hidden = false;
        } else {
          stickyCompare.hidden = true;
        }
      }

      atcButtons.forEach(function (btn) {
        btn.disabled = !available;
        if (!available) btn.textContent = 'Tükendi';
      });
      if (stickySubmit) {
        stickySubmit.disabled = !available;
        if (!available) stickySubmit.textContent = 'Tükendi';
      }

      updateVisiblePrices();
      syncGalleryForVariant(selected);
    }

    variantSelect && variantSelect.addEventListener('change', syncVariant);
    syncVariant();

    section.querySelectorAll('[data-vibee-pdp-bundle-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.dataset.loading === '1') return;
        var root = section.querySelector('[data-vibee-bundle]');
        var items = [];
        if (root) {
          var seedHandle = root.getAttribute('data-seed-handle') || '';
          var buddyHandle = root.getAttribute('data-buddy-handle') || '';
          var buddySelected = false;
          root.querySelectorAll('[data-bundle-item]').forEach(function (c) {
            var id = c.getAttribute('data-id');
            if (!c.checked || !id) return;
            if (c.getAttribute('data-seed') !== 'true') buddySelected = true;
            items.push({ id: Number(id), quantity: 1 });
          });
          if (buddySelected && items.length >= 2 && seedHandle && buddyHandle) {
            var bundleId = seedHandle + '__' + buddyHandle;
            items = items.map(function (item) {
              return {
                id: item.id,
                quantity: item.quantity,
                properties: { _bundle_id: bundleId }
              };
            });
          }
        }
        if (!items.length) return;
        btn.dataset.loading = '1';
        var lbl = btn.querySelector('[data-bundle-cta-label]');
        var prev = lbl ? lbl.textContent : '';
        if (lbl) lbl.textContent = root ? (root.getAttribute('data-label-adding') || 'Ekleniyor…') : 'Ekleniyor…';
        vibeeCartAddAndSync({
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items }),
        })
          .then(function () {
            if (lbl) lbl.textContent = prev;
          })
          .catch(function () {
            if (window.vibeeCartDrawer && typeof window.vibeeCartDrawer.showError === 'function') {
              window.vibeeCartDrawer.showError(
                root
                  ? root.getAttribute('data-label-error') || undefined
                  : undefined,
              );
            }
            if (lbl) {
              lbl.textContent = root
                ? root.getAttribute('data-label-error') || 'Sepete eklenemedi — tekrar dene'
                : 'Sepete eklenemedi — tekrar dene';
              window.setTimeout(function () {
                if (lbl) lbl.textContent = prev;
              }, 3200);
            }
          })
          .finally(function () {
            btn.dataset.loading = '0';
          });
      });
    });

    if (stickySubmit && buyForm) {
      stickySubmit.addEventListener('click', function () {
        if (purchaseSelector && resolvePurchaseAction() === 'external') {
          goExternal();
          return;
        }
        safeSubmit(buyForm);
      });
    }

    if (stickyModule && atcSentinel && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        stickyModule.classList.toggle('is-visible', !entries[0].isIntersecting);
        if (typeof window.vibeeSyncStickyAtcHeight === 'function') {
          window.requestAnimationFrame(window.vibeeSyncStickyAtcHeight);
        }
      }, { threshold: 0, rootMargin: '0px' });
      stickyObserver.observe(atcSentinel);
    }

    var bundleRoot = section.querySelector('[data-vibee-bundle]');
    if (bundleRoot) {
      var checks = bundleRoot.querySelectorAll('[data-bundle-item]');
      var totalNode = bundleRoot.querySelector('[data-bundle-total]');
      var actionsNode = bundleRoot.querySelector('[data-bundle-actions]');
      var ctaBtn = bundleRoot.querySelector('[data-vibee-pdp-bundle-select]');
      var unlockQty = Number(bundleRoot.getAttribute('data-bundle-unlock-qty') || 2);
      var unlockPct = Number(bundleRoot.getAttribute('data-bundle-unlock-pct') || 15);
      var clubMultiplier = Number(bundleRoot.getAttribute('data-club-multiplier') || 5);
      var labelCta = bundleRoot.getAttribute('data-label-cta') || 'SETİ SEPETE EKLE';
      var labelDiscount = bundleRoot.getAttribute('data-label-discount') || '{{ percent }} indirim · {{ savings }} tasarruf';
      var labelClub = bundleRoot.getAttribute('data-label-club') || 'Set ile ~{{ points }} Vibees+ puanı kazanırsın';

      function formatClubPoints(priceCents) {
        var priceTl = Math.floor(Number(priceCents || 0) / 100);
        var rawPoints = priceTl * clubMultiplier;
        var remainder = rawPoints % 50;
        var points = rawPoints - remainder;
        if (remainder >= 25) points += 50;
        return points;
      }

      function formatTrInteger(n) {
        var s = String(Math.max(0, Math.floor(Number(n || 0))));
        return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }

      function syncCheckVisual(input) {
        var item = input.closest ? input.closest('.vibee-pdp__bundle-item') : null;
        if (!item) return;
        var checked = input.checked || input.disabled;
        item.classList.toggle('is-selected', checked);
        var toggleBtn = item.querySelector('[data-bundle-toggle]');
        if (toggleBtn) {
          toggleBtn.setAttribute('aria-pressed', checked ? 'true' : 'false');
          var label = checked ? toggleBtn.getAttribute('data-label-remove') : toggleBtn.getAttribute('data-label-add');
          if (label) toggleBtn.setAttribute('aria-label', label);
        }
      }

      function recalcBundle() {
        var discountedNode = bundleRoot.querySelector('[data-bundle-discounted]');
        var badgeNode = bundleRoot.querySelector('[data-bundle-badge]');
        var clubNode = bundleRoot.querySelector('[data-bundle-club-points]');
        var count = 0;
        var ham = 0;
        checks.forEach(function (c) {
          syncCheckVisual(c);
          if (!c.checked) return;
          count += 1;
          ham += Number(c.getAttribute('data-price') || 0);
        });
        var discountPct = count >= unlockQty ? unlockPct : 0;
        var discounted = Math.round(ham * (100 - discountPct) / 100);
        var savings = ham - discounted;
        var isActive = discountPct > 0;

        if (totalNode) {
          totalNode.textContent = money(ham);
          totalNode.hidden = !isActive;
        }
        if (discountedNode) {
          discountedNode.textContent = money(discounted);
        }
        if (badgeNode) {
          if (isActive) {
            badgeNode.hidden = false;
            badgeNode.textContent = labelDiscount
              .replace(/\{\{\s*percent\s*\}\}/g, '%' + String(discountPct))
              .replace(/\{\{\s*savings\s*\}\}/g, money(savings));
          } else {
            badgeNode.hidden = true;
          }
        }
        if (clubNode) {
          var pts = formatClubPoints(isActive ? discounted : 0);
          clubNode.textContent = labelClub.replace(/\{\{\s*points\s*\}\}/g, formatTrInteger(pts));
        }
        if (actionsNode) {
          actionsNode.classList.toggle('is-disabled', !isActive);
        }
        if (ctaBtn) {
          ctaBtn.disabled = !isActive;
        }
      }

      checks.forEach(function (c) {
        c.addEventListener('change', recalcBundle);
        syncCheckVisual(c);
      });

      // Circular +/✓ button toggles the hidden checkbox; recalcBundle
      // listens on the input's change event, so cart add logic is untouched.
      bundleRoot.querySelectorAll('[data-bundle-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.vibee-pdp__bundle-item');
          var input = item ? item.querySelector('[data-bundle-item]') : null;
          if (!input || input.disabled) return;
          input.checked = !input.checked;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      recalcBundle();
    }

    initBeforeAfter(section);
    initQuiz(section);
    initShadeSelector(section);
    initShadeQuiz(section);
  }

  document.querySelectorAll('[data-vibee-pdp]').forEach(function (section) {
    try {
      initSection(section);
    } catch (e) {
      console.error('vibee-pdp: section init failed', e);
    }
  });

  // ── AG100 public duyuru bandı (Tem 2026) ──
  // Güneş ikilisinde kod herkese açık. UYGULA sayfayı YÖNLENDİRMEZ:
  // kod arka planda fetch ile uygulanır, bant anında "✓ UYGULANDI" olur.
  (function () {
    try {
      var path = (location.pathname || '').toLowerCase();
      if (path.indexOf('gunes-kremi-spf-50') === -1) return;
      var form = document.querySelector('[data-vibee-pdp-atc-form]');
      if (!form || document.querySelector('.vibee-pdp__ag-bar')) return;

      var TAG_SVG =
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2 3 3l-1 9 10 10 9-9L12 2Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="7.5" cy="7.5" r="1.5" fill="currentColor"/></svg>';
      function currentDiscountCodes() {
        try {
          var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
          if (!m) return [];
          return decodeURIComponent(m[1]).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        } catch (e) {
          return [];
        }
      }

      // location.pathname ZATEN yüzde-kodlu; tekrar encode = çifte-kodlama + 404.
      // Tam paket (Tem 2026 kararı): tek dokunuş = AG100 (−100) + SANSKARGO (kargo 0).
      // Mevcut cookie kodları korunur, eksik olanlar yanına eklenir.
      var BAR_CODES = ['AG100', 'SANSKARGO'];

      function buildApplyUrl() {
        var codes = currentDiscountCodes();
        BAR_CODES.forEach(function (want) {
          var has = codes.some(function (c) { return c.toUpperCase() === want; });
          if (!has) codes.push(want);
        });
        return '/discount/' + codes.join(',') + '?redirect=' + location.pathname;
      }

      function codeApplied() {
        var codes = currentDiscountCodes().map(function (c) { return c.toUpperCase(); });
        return BAR_CODES.every(function (want) { return codes.indexOf(want) !== -1; });
      }

      // Kalıcı uygulama: kodları SEPETİN kendisine yazar (/cart/update.js).
      // Cookie'den farkı: checkout'a giriş-çıkışlarda tükenmez, her checkout'a taşınır.
      function applyCodesToCart() {
        return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
            BAR_CODES.forEach(function (want) {
              var has = codes.some(function (c) { return String(c).toUpperCase() === want; });
              if (!has) codes.push(want);
            });
            return fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: codes.join(',') }),
            });
          })
          .then(function (r) {
            if (!r.ok) throw new Error('cart_discount_failed');
            return r;
          });
      }

      // Sayfa açılışında sepetteki kodlara bak — ikisi de varsa bandı uygulanmış göster.
      function syncAppliedFromCart(bar) {
        fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var codes = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
            var all = BAR_CODES.every(function (want) { return codes.indexOf(want) !== -1; });
            if (all) renderApplied(bar);
          })
          .catch(function () {});
      }

      function renderApplied(bar) {
        bar.classList.add('is-applied');
        bar.removeAttribute('href');
        bar.setAttribute('role', 'status');
        bar.innerHTML =
          TAG_SVG +
          '<span class="vibee-pdp__ag-bar-text"><strong>AG100</strong> + ücretsiz kargo uygulandı</span>' +
          '<span class="vibee-pdp__ag-bar-cta">✓</span>';
      }

      var bar = document.createElement('a');
      bar.className = 'vibee-pdp__ag-bar';
      bar.href = buildApplyUrl();
      bar.innerHTML =
        TAG_SVG +
        '<span class="vibee-pdp__ag-bar-text"><strong>AG100</strong> −100 TL + ÜCRETSİZ KARGO</span>' +
        '<span class="vibee-pdp__ag-bar-cta">UYGULA</span>';
      form.insertAdjacentElement('beforebegin', bar);

      if (codeApplied()) {
        renderApplied(bar);
        return;
      }
      syncAppliedFromCart(bar);

      bar.addEventListener('click', function (event) {
        event.preventDefault();
        if (bar.classList.contains('is-applied') || bar.dataset.applying === '1') return;
        bar.dataset.applying = '1';
        var cta = bar.querySelector('.vibee-pdp__ag-bar-cta');
        if (cta) cta.textContent = '…';
        applyCodesToCart()
          .then(function () {
            renderApplied(bar);
          })
          .catch(function () {
            // Ağ hatasında eski güvenli yol: cookie navigasyonu
            window.location.assign(buildApplyUrl());
          });
      });
    } catch (e) {}
  })();

  // Back-in-stock lead capture: Klaviyo client API (24 Aug 2026).
  function initBackInStock(form) {
    if (form.dataset.vibeeBisInit === 'true') return;
    form.dataset.vibeeBisInit = 'true';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var email = input ? String(input.value || '').trim() : '';
      if (!email) return;
      var root = form.closest('[data-back-in-stock]');
      var variantId = root ? root.getAttribute('data-variant-id') : '';
      // Klaviyo Back in Stock aboneligi: restock'ta "Bekleyisin bitti" maili
      // (flow: Back in Stock - Tekrar Stokta) otomatik tetiklenir.
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Ts6xDY', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2025-04-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + variantId
                }
              }
            }
          }
        })
      }).catch(function () {});
      form.hidden = true;
      if (root) {
        var done = root.querySelector('[data-vibee-bis-done]');
        if (done) done.hidden = false;
      }
    });
  }

  document.querySelectorAll('[data-vibee-bis-form]').forEach(initBackInStock);
})();

/* ---------------------------------------------------------------
 * Galeri video autoplay
 * Galerideki video, slaytı görünür olunca sessiz + loop oynar;
 * slayttan çıkınca durur. Masaüstü: crossfade katmanına klonlanan
 * videoyu MutationObserver yakalar. Mobil: yatay şeritteki videoyu
 * IntersectionObserver yakalar. Kontroller açık kalır (ses açılabilir).
 * ------------------------------------------------------------- */
(function () {
  function arm(video) {
    if (!video) return;
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.loop = true;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function halt(video) {
    if (!video) return;
    try { video.pause(); } catch (e) {}
  }

  document.querySelectorAll('[data-vibee-pdp-gallery-layers]').forEach(function (layers) {
    var sync = function () {
      layers.querySelectorAll('.vibee-pdp__gallery-layer').forEach(function (layer) {
        var video = layer.querySelector('video');
        if (!video) return;
        if (layer.classList.contains('is-active')) {
          if (!video.dataset.vibeeArmed) {
            video.dataset.vibeeArmed = '1';
            arm(video);
          }
        } else {
          halt(video);
        }
      });
    };
    new MutationObserver(sync).observe(layers, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    sync();
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) arm(entry.target);
        else halt(entry.target);
      });
    }, { threshold: [0, 0.6] });
    document.querySelectorAll('[data-vibee-pdp-mobile-track] video').forEach(function (video) {
      io.observe(video);
    });
  }
})();

